/* eslint-disable */
import axios from "axios";
import "/src/assets/css/animate.css";
import "/src/assets/css/style.css";
import { useStore } from "vuex";
import moment from "moment";
import Chart from "chart.js";
import jwt_decode from "jwt-decode";
import store from "@/store";
import SubjectSchedule from "./SubjectSchedule.vue";
import VPagination from "@hennge/vue3-pagination";
import SoaTree from "./SoaTree.vue";
import StatusAuditModal from "./FieldAuditPopup.vue";
import RandomizationModal from "../Randomization/RandomizationModal.vue";
import VisitActivityTree from "../VisitActivityTree/VisitActivityTree.vue";
import customModal from "../customModal/customModal.vue";
import { version } from "vuex/dist/vuex.cjs.js";
import VuePdfEmbed from 'vue-pdf-embed';

import aetablemodel from "./aetablemodel.vue"
import showformmodel from "../showformmodel/showformmodel.vue"
export default {
  name: "subjectprofile",

  components: {
    SubjectSchedule,
    customModal,
    SoaTree,
    StatusAuditModal,
    RandomizationModal,
    VPagination,
    VisitActivityTree,
    VuePdfEmbed,
    aetablemodel,
    showformmodel
  },

  props: {
    subjectId: {
      type: String,
      required: true,

    },
  },

  data() {
    return {
      selectedclass: "selectedsubjectmenu subject-profile-sidebar__link",
      nonselectedclass: "subject-profile-sidebar__link",
      selectedmenu: "SoA",
      defaultdate: "",
      SortOrder:0,
            SortProperty:"",
             activeSortColumn: "",
      selectedDocumentVersion: "",
      selectedConsentType: "",
      selectedFormHtml: '',
      selectedConsentRecord: null,
      selectedFormName: '',
      consentdocumentauditpopup: false,
      setshowFormModal: false,
      currentform: "",
      aetimelineList: [],
      cmtimelineList: [],
      mhtimelineList: [],
      consentFormsTotalPages: 0,
      consentFormsPageIndex: 1,
      aeTimelineCurrentPage: 1,
      aeTimelinePageSize: 10,
      aeTimelineTotalPages: 0,
      cmTimelineCurrentPage: 1,
      cmTimelinePageSize: 10,
      mhTimelinePageSize: 10,
      cmTimelineTotalPages: 0,
      mhTimelineCurrentPage: 1,
      mhTimelineTotalPages: 0,
      tilevalues: {
        totalAEs: 0,
        grade3PlusAEs: 0,
        saEs: 0,
        susaRs: 0
      },
      consentauditpopup: false,
      showSidePopup: [],
      consentAuditDetails: [],
      showInvitePopup: false,
      consentList: [],
      isInviting: false,
      inviteButtonstats: true,
      defaultTime: "",
      subjectid: "",
      patient: null,
      baseapi: process.env.VUE_APP_Service_URL,
      ItemID: "",
      auditpopup: false,
      auditLists: [],
      changeHeight: false,
      audithistortpopup: false,
      auditdetails: [],
      AuditId: "",
      auditHistoryLists: [],
      isEditMode: false,
      editablePatient: {},
      statusList: [],
      milestoneList: [],
      showStatusAudit: false,
      showRandomizationModal: false,
      fieldNameForAudit: "",
      tableName: "",
      name: "",
      patientId: "",
      users: [],
      countries: [],
      languages: [],
      screeningError: false,
      cohortList: [],
      consentType: "",
      inviteEmail: "",
      documentUploadpopup: false,
      eConsentForms: [],
      selectedTemplateId: "",
      inviteConsentType: "",
      selectedDocumentId: "",
      eConsentTemplates: [],
      documentList: [],
      showDocumentLoading: false,
      showDocumentViewModal: false,
      currentDocument: {},
      documentLoading: false,
      auditEvents: [],
      isLoadingAudit: false,
      documentPreviewLoading: false,
      documentSource: "",
      documentFormat: "",
      officePreviewUrl: "",
      officeFormats: ['xls', 'xlsx', 'doc', 'docx'],
      imageFormats: ['jpg', 'jpeg', 'png', 'gif'],
      SortProperty: "CreatedAt",
      pageindex: 1,
      pagesize: 10,
      SortOrder: 1,
      expandedMetadataIndex: null,
      aetableresult: [],
      aetableloading: false,
      aetype: "",
      openaetable: false,
      aetabletitle: "AE Data",
      selectedFormPdfUrl: '',
      isFormLoading: false,
      urlStatus: false,
      signStatus: false,
      err: "",
      subjectConsentForms: [],
      availableICFForms: [],
      inviteFormErrors: {
        selectedDocumentId: "",
        selectedTemplateId: "",
        inviteEmail: "",
      },
      uploadedConsentFile: null,
      uploadingFile: false,
      consentRecordId: "",
      patientLogin: {}
    };
  },
  watch: {
    selectedmenu(newVal) {
      if (newVal === 'Document' && this.subjectConsentForms.length === 0) {
        this.getDocuments();
      }
    }
  },
  computed: {
    sourceTab() {
      return this.$route.query.sourceTab || "";
    },
    showReConsentButton() {
      return this.sourceTab !== "subject";
    },
    showEConsentButton() {
      return this.sourceTab !== "reconsent";
    },
    hasCompletedConsent() {
      return this.subjectConsentForms.some(
        item => item.status?.toLowerCase() === "completed"
      );
    },
    //    haseconsentcompleted() {
    //   return this.subjectConsentForms.some(
    //     item =>
    //       // item.consentType?.toLowerCase() === "econsent" &&
    //       item.outcome?.toLowerCase() === "consented"
    //   );
    // },
    haseconsentcompleted() {
      return (
        this.subjectConsentForms.length > 0 &&
        this.subjectConsentForms.every(
          item => item.outcome?.toLowerCase() === "consented"
        )
      );
    },
  }, 
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.previousRoute = from.fullPath;
    });
  },
  beforeMount() {
    store.dispatch("setNavbar", true);
    const pageWrapper = document.getElementById("page-wrapper");
    if (pageWrapper) {
      pageWrapper.style.width = "100%";
      pageWrapper.style.minHeight = "100vh";
      pageWrapper.style.height = "100vh";
    }
    const getselectedmenu = localStorage.getItem("selectedmenu");
    if (getselectedmenu && getselectedmenu != "") {
      this.selectedmenu = getselectedmenu;
    }
    if (this.$route.query.tab === 'document') {
    this.selectedmenu = 'Document';
  }

  },
  mounted() {
    this.defaultdate = localStorage.getItem("dateformat");
    this.defaultTime = localStorage.getItem("timeformat");
    this.getUsers();
    this.getCountries();
    this.getLanguages();
    this.getPatientById();
    this.getSubjectStatus();
    this.getSubjectMilestones();
    this.getCohortList();
    this.getaesummary();
    this.getAetimeline();
    this.getcmtimeline();
    this.getEConsentForms();
    this.getmhtimeline();
    this.getDocuments();
    this._eConsentHandler = () => {
      this.getPatientById();

      if (this.selectedmenu === 'Document') this.getDocuments();
      this.getConsentDocuments();


    };
    window.addEventListener("eConsentUpdated", this._eConsentHandler);
  },

  beforeUnmount() {
    localStorage.setItem("selectedmenu", this.selectedmenu)
    window.removeEventListener("eConsentUpdated", this._eConsentHandler);
    store.dispatch("setNavbar", true);
    const pageWrapper = document.getElementById("page-wrapper");
    if (pageWrapper) {
      pageWrapper.style.removeProperty("width");
      pageWrapper.style.removeProperty("min-height");
      pageWrapper.style.removeProperty("height");
    }
  },


  methods: {
    onConsentFileChange(event) {
      this.uploadedConsentFile = event.target.files?.[0] || null;
    },
    async uploadWetInkDocument() {

      const artifactId = "'05.04.11'";
      const idtoken = store.getters.getIdToken;
      const studyId = store.getters.getStudyIs;

      const formData = new FormData();
      formData.append("file", this.uploadedConsentFile);

      // Add these only if your API expects them
      formData.append("ArtifactId", artifactId);
      formData.append("ConsentRecordId", this.consentRecordId);
      formData.append("StudyId", studyId);
      formData.append("SubjectId", this.patient.patientId);
      formData.append("SiteId", this.patient.siteId);
      formData.append("Version", this.selectedDocumentVersion);

      const response = await axios.post(
        `${this.baseapi}/management/patientdocument/uploadwetinkdocument`,
        formData,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    },
    async getPatientloginInfo() {

      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseapi}/account-core/user/subjectbyid?subjectId=${this.patient.patientId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.patientLogin = res.data || {};
          if (this.patientLogin.emailID) {
            this.inviteEmail = this.patientLogin.emailID;
          }
        })
        .catch((err) => {
          console.log(" error get patient login", err);
          this.patientLogin = {};
        });
    },
    async viewforms(fomid) {
      this.currentform = fomid;
      this.setshowFormModal = true;
    },
    closeformModal() {
      this.setshowFormModal = false;
    },
    async showtablepopup(aetype, title) {
      this.aetableresult = [];
      this.aetype = aetype;
      this.aetabletitle = title;
      this.openaetable = true;
    },
    closetablepopup() {
      this.openaetable = false;
      this.aetype = "";
    },
    decideclass(menuitem) {
      if (this.selectedmenu === menuitem) {
        return this.selectedclass;
      }
      else {
        return this.nonselectedclass;
      }
    },
    setselectedmenu(menuitem) {
      this.selectedmenu = menuitem;
      if (menuitem === 'Document') {
        this.getDocuments();
      }
    },
    handleScreeningFailedChange() {
      if (!this.editablePatient.isScreeningFailed) {
        this.screeningError = false;
        this.editablePatient.screeningFailureReason = '';
      }
    },
    async Upload() {

    },
    async getPatientById() {
      const idtoken = store.getters.getIdToken;

      try {
        const response = await axios.get(
          `${this.baseapi}/management/patient/getpatientbyid/${this.subjectId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.patient = response.data;
        console.log("Patient Data:", this.patient);


        this.mapConsentData();
      } catch (error) {
        console.error("Error fetching patient:", error);
      }
    },
    async mapConsentData() {
      const auditDetails = await this.getAuditCompletionDetails(this.patient.patientId);
      this.consentList = [{
        id: this.patient.patientId,
        sentBy: this.patient.createdUserName || 'System Admin',
        createdDate: this.patient.createdAt,
        consentStatus: this.patient.consentStatus,
        signedDate: this.patient.consentSignedDate,
        reConsentRequired: this.patient.reConsentRequired,
        currentIcfForm:this.patient.currentIcfForm,
        currentIcfVersion: this.patient.currentIcfVersion,
        consnetFormViewedBy: this.patient.consnetFormViewedBy,
        consnetFormViewedAt: this.patient.consnetFormViewedAt,
        formVerifiedBy: this.patient.formVerifiedBy,
        formVerifiedAt: this.patient.formVerifiedAt,
        markedCompleteBy: auditDetails?.auditCompletionBy || null,
        completionDate: auditDetails?.completionDate || null
      }];
    },

    formatDate(dateString) {
      if (!dateString) return 'Not set';
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        });
      } catch {
        return 'Invalid date';
      }
    },

    formatTime(dateString) {
      if (!dateString) return '';
      try {
        const date = new Date(dateString);
        return date.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true
        });
      } catch {
        return '';
      }
    },
    getBadgeClass(status) {
      switch (status) {
        case 'Consented':
          return 'badge-success';
        case 'Awaiting consent':
          return 'badge-primary';
        case 'Dissented':
          return 'badge-danger';
        default:
          return 'badge-secondary';
      }
    },

    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString();
    },
    openModelaudit(patID) {
      document.body.style.overflowY = "hidden";
      this.auditpopup = true;
      this.ItemID = this.patient.patientId;

      this.getAuditdetails();
    },
    openModelconsentaudit(patID) {
      document.body.style.overflowY = "hidden";
      this.consentauditpopup = true;
      this.ItemID = this.patient.patientId;

      this.getPatientById();
    },
    async openAuditModal(
      consentRecordId,
      selectedDocument = null,
      index = null
    ) {

      if (index !== null) {
        this.showSidePopup[index] = false;
      }

      document.body.style.overflowY = "hidden";

      this.consentdocumentauditpopup = true;

      this.consentList = [];

      await this.fetchConsentAuditData(consentRecordId);
    },

    openRandomizationPopup() {
      this.showRandomizationModal = true;
      this.ItemID = this.patient.patientId;
    },
    openModeleconsent(id, name) {
      this.openInvitePopup({
        subjectId: id || this.patient?.patientId || this.subjectId,
        studyId: name || this.patient?.studyId || "",
        consentType: "eConsent",
      });
    },
    openModelereconsent() {
      this.openInvitePopup({
        subjectId: this.patient?.patientId || this.subjectId,
        studyId: this.patient?.studyId || "",
        consentType: "ReConsent",
      });
    },
    openInvitePopup({ subjectId, studyId, consentType }) {
      this.resetInvitePopupState();
      this.showInvitePopup = true;
      this.inviteConsentType = consentType;
      this.consentType = "eConsent";
      this.subjectid = subjectId;
      this.name = studyId;
      this.getEConsentForms();
      this.getConsentDocuments();
      this.getPatientloginInfo();
    },
    resetInviteValidation() {
      this.inviteFormErrors = {
        selectedDocumentId: "",
        selectedTemplateId: "",
        inviteEmail: "",
      };
    },
    resetInvitePopupState() {
      this.consentType = "";
      this.uploadedConsentFile = null;
      this.inviteEmail = "";
      this.selectedTemplateId = "";
      this.selectedDocumentId = "";
      this.selectedFormHtml = "";
      this.selectedFormPdfUrl = "";
      this.selectedFormName = "";
      this.err = "";
      this.isInviting = false;
      this.inviteButtonstats = true;
      this.resetInviteValidation();
    },
    closeInvitePopup() {
      this.showInvitePopup = false;
      this.resetInvitePopupState();
    },
    getInviteEmailPattern() {
      return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    },
    validateInviteField(fieldName) {
      switch (fieldName) {
        case "selectedDocumentId":
          this.inviteFormErrors.selectedDocumentId = this.selectedDocumentId
            ? ""
            : "Please select a consent form.";
          break;
        case "selectedTemplateId":
          this.inviteFormErrors.selectedTemplateId = this.selectedTemplateId
            ? ""
            : "Please select an eCRF form.";
          break;
        case "inviteEmail": {
          const email = (this.inviteEmail || "").trim();

          if (!email) {
            this.inviteFormErrors.inviteEmail = "Please enter an email.";
          } else if (!this.getInviteEmailPattern().test(email)) {
            this.inviteFormErrors.inviteEmail = "Please enter a valid email.";
          } else {
            this.inviteFormErrors.inviteEmail = "";
          }
          break;
        }
        default:
          break;
      }

      return !this.inviteFormErrors[fieldName];
    },
    validateInviteForm() {
      const documentValid =
        this.validateInviteField("selectedDocumentId");

      const templateValid =
        this.validateInviteField("selectedTemplateId");

      // Skip email validation for ReConsent
      let emailValid = true;

      if ( this.consentType !== "Wet Ink") {
        emailValid =
          this.validateInviteField("inviteEmail");
      }

      return (
        documentValid &&
        templateValid &&
        emailValid
      );
    },
    onConsentDocumentChange() {
      this.err = "";

      const selectedDoc = this.availableICFForms.find(
        x => (x.documentId || x.id) === this.selectedDocumentId
      );

      this.selectedDocumentVersion = selectedDoc?.versionNumber || "";

      console.log("Selected Version:", this.selectedDocumentVersion);

      this.validateInviteField("selectedDocumentId");
      this.updateInviteButtonState();
    },
    // onConsentDocumentChange() {
    //   this.err = "";
    //   this.validateInviteField("selectedDocumentId");
    //   this.updateInviteButtonState();
    // },

    async getSelectedTemplate(tempid) {
      const selectedTemplate = this.eConsentTemplates.find(
        (template) => template.templateId === tempid
      );

      this.selectedFormName = selectedTemplate?.templateName || "";
      return selectedTemplate || null;
    },
    async getdata(tempid) {
      return await this.getSelectedTemplate(tempid || this.selectedTemplateId);
    },
    async onFormChange() {
      this.selectedFormHtml = '';
      this.selectedFormPdfUrl = '';
      this.selectedFormName = '';
      this.err = "";
      this.inviteButtonstats = true;

      if (this.selectedTemplateId) {
        await this.getSelectedTemplate(this.selectedTemplateId);
      }

      this.validateInviteField("selectedTemplateId");
      this.updateInviteButtonState();
    },

    openDocumetUploadModel() {
      this.documentUploadpopup = true;
    },
    handleCloseDocumentUpload() {
      this.documentUploadpopup = false;
    },
    async getcmtimeline(page = this.cmTimelineCurrentPage) {
       const studyId = store.getters.getStudyIs;
      const token = store.getters.getIdToken;
      this.cmTimelineCurrentPage = page;
      await axios.get(
        `${this.baseapi}/forms/reports/cmtimeline?studyId=${studyId}&subjectId=${this.subjectId}&pageindex=${page}&pagesize=${this.cmTimelinePageSize}`,
        { headers: { Authorization: "Bearer " + token } }
      )
        .then((res) => {
          const results = res.data.results || [];
          const totalCount =
            res.data.totalCount !== undefined && res.data.totalCount !== null
              ? res.data.totalCount
              : res.data.count !== undefined && res.data.count !== null
                ? res.data.count
                : results.length;

          this.cmtimelineList = results;
          this.cmTimelineTotalPages = totalCount
            ? Math.ceil(totalCount / this.cmTimelinePageSize)
            : 0;
        });
    },
    async getmhtimeline(page = this.mhTimelineCurrentPage) {
      const studyId = store.getters.getStudyIs;
      const token = store.getters.getIdToken;
      this.mhTimelineCurrentPage = page;
      await axios.get(
        `${this.baseapi}/forms/reports/mhtimeline?studyId=${studyId}&subjectId=${this.subjectId}&pageindex=${page}&pagesize=${this.mhTimelinePageSize}`,
        { headers: { Authorization: "Bearer " + token } }
      )
        .then((res) => {
          const results = res.data.results || [];
          const totalCount =
            res.data.totalCount !== undefined && res.data.totalCount !== null
              ? res.data.totalCount
              : res.data.count !== undefined && res.data.count !== null
                ? res.data.count
                : results.length;

          this.mhtimelineList = results;
          this.mhTimelineTotalPages = totalCount
            ? Math.ceil(totalCount / this.mhTimelinePageSize)
            : 0;
        });
    },
    async getaesummary() {
       const studyId = store.getters.getStudyIs;
      const token = store.getters.getIdToken;
      await axios.get(
        `${this.baseapi}/forms/reports/aesummary?studyId=${studyId}&subjectId=${this.subjectId}`,
        { headers: { Authorization: "Bearer " + token } }
      )
        .then((res) => {
          this.tilevalues.totalAEs = res.data.totalAEs;
          this.tilevalues.grade3PlusAEs = res.data.grade3PlusAEs;
          this.tilevalues.saEs = res.data.saEs;
          this.tilevalues.susaRs = res.data.susaRs;
        });
    },
    async SortSelected(property) {
      // Toggle sorting direction if same column clicked again
      if (this.SortProperty === property) {
        this.SortOrder = this.SortOrder === 0 ? 1 : 0;
      } else {
        this.SortProperty = property;
        this.SortOrder = 0; // Default ascending
      }

      this.activeSortColumn = property;
      console.log(`Sorting by ${property}, order: ${this.SortOrder}`);
      await this.getAetimeline();
    },
    async getAetimeline(page = this.aeTimelineCurrentPage) {
       const studyId = store.getters.getStudyIs;
  const token = store.getters.getIdToken;
  this.aeTimelineCurrentPage = page;

  await axios.get(
    `${this.baseapi}/forms/reports/aetimeline?studyId=${studyId}&subjectId=${this.subjectId}&pageindex=${page}&pagesize=${this.aeTimelinePageSize}&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrder}`,
    { headers: { Authorization: "Bearer " + token } }
  )
  .then((res) => {
    const results = res.data.results || [];
    const totalCount =
      res.data.totalCount !== undefined && res.data.totalCount !== null
        ? res.data.totalCount
        : res.data.count !== undefined && res.data.count !== null
          ? res.data.count
          : results.length;

    this.aetimelineList = results;
    this.aeTimelineTotalPages = totalCount
      ? Math.ceil(totalCount / this.aeTimelinePageSize)
      : 0;

    console.log("AE Timeline is", this.aetimelineList);
  });
}
,
    // async getAetimeline(page = this.aeTimelineCurrentPage) {
    //   const token = store.getters.getIdToken;
    //   this.aeTimelineCurrentPage = page;
    //   await axios.get(
    //     `${this.baseapi}/forms/reports/aetimeline?subjectId=${this.subjectId}&pageindex=${page}&pagesize=${this.aeTimelinePageSize}&SortOrder=${this.aeTimelineSortOrder}&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrder}`,
    //     { headers: { Authorization: "Bearer " + token } }
    //   )
    //     .then((res) => {
    //       const results = res.data.results || [];
    //       const totalCount =
    //         res.data.totalCount !== undefined && res.data.totalCount !== null
    //           ? res.data.totalCount
    //           : res.data.count !== undefined && res.data.count !== null
    //             ? res.data.count
    //             : results.length;

    //       this.aetimelineList = results;
    //       this.aeTimelineTotalPages = totalCount
    //         ? Math.ceil(totalCount / this.aeTimelinePageSize)
    //         : 0;
    //       console.log("AE Timeline is", this.aetimelineList);
    //     });
    // },
    loadAeTimelinePage(page) {
      this.getAetimeline(page);
    },
    loadMhTimelinePage(page) {
      this.getmhtimeline(page);
    },
    loadCmTimelinePage(page) {
      this.getcmtimeline(page);
    },
    async getAuditdetails() {
      const token = store.getters.getIdToken;
      console.log("item id is", this.ItemID);
      await axios
        .get(
          `${this.baseapi}/management/audit/getaudits?AuditTable=Management&ItemID=${this.ItemID}&Sort=Desc`,
          { headers: { Authorization: "Bearer " + token } }
        )
        .then((res) => {
          this.auditLists = res.data.data;
          if (res.data.count > 4) {
            this.changeHeight = true;
          } else {
            this.changeHeight = false;
          }
          console.log("Audit Trial list is", this.auditLists);

          console.log(res);
        });
    },
    filter(data) {
      if (data) {
        return moment(data).format(this.defaultdate);
      }
    },
    formatdatetime(data) {
      if (data) {
        return moment(data).format(this.defaultdate)
      }
    },
    toTime(data) {
      if (data) {
        return moment(data).format(this.defaultTime);
      }
    },
    closemodallll() {
      console.log("close modal");
      document.body.style.overflowY = "auto";
      this.auditpopup = false;
    },
    closemodels() {

      document.body.style.overflowY = "auto";
      this.consentauditpopup = false;
    },
    closeconsentmodels() {
      document.body.style.overflowY = "auto";
      this.consentdocumentauditpopup = false;
      this.expandedMetadataIndex = null;
    },
    openModelauditOps(audID) {
      console.log("audit id issssssssssssssssssssssssssssss", audID);
      this.audithistortpopup = true;
      this.AuditId = audID;
      console.log("audit id is......?", this.AuditId);
      this.getAuditHistory();
    },
    async getAuditHistory() {
      console.log("audit Id is...", this.AuditId);
      await axios
        .get(
          `${this.baseapi}/management/audit/getaudit?AuditId=${this.AuditId}&auditTable=Management`
        )
        .then((res) => {
          this.auditHistoryLists = res.data;
          console.log("Audit History List issssss", this.auditHistoryLists);
          console.log(res);
        });
    },
    closehistorymodal() {
      console.log("close modal");
      this.audithistortpopup = false;
    },
    enableEdit() {
      this.selectedmenu = "SubjectOverview";
      this.isEditMode = true;
      this.editablePatient = {
        ...this.patient,
        siteId: this.patient.siteId,
        consentSignedDate: this.formatDateForInput(this.patient.consentSignedDate),
        screeningDate: this.formatDateForInput(this.patient.screeningDate),
        enrollmentDate: this.formatDateForInput(this.patient.enrollmentDate),
        randomizationDate: this.formatDateForInput(this.patient.randomizationDate)
      };
    },
    formatDateForInput(date) {
      if (!date) return null;

      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    },
    cancelEdit() {
      this.isEditMode = false;
    },
    async getSubjectStatus() {
      const idtoken = store.getters.getIdToken;

      const res = await axios.get(
        `${this.baseapi}/management/statusmaster/getall?StatusType=Subject`,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
          },
        }
      );

      this.statusList = res.data;
    },

    async getSubjectMilestones() {
      const idtoken = store.getters.getIdToken;
      let studyId = store.getters.getStudyIs;

      const res = await axios.get(
        `${this.baseapi}/management/patient/listsubjectmilestone?studyId=${studyId}`,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
          },
        }
      );

      this.milestoneList = res.data.data || [];
    },
    openStatusAudit(fieldName) {
      this.fieldNameForAudit = fieldName;
      this.tableName = "Management";
      this.patientId = this.patient.patientId;
      this.showStatusAudit = true;
    },
    toISOString(date) {
      return date ? new Date(date).toISOString() : null;
    },
    saveEdit() {
      const idtoken = store.getters.getIdToken;
      this.screeningError = false;

      if (this.editablePatient.isScreeningFailed) {
        if (!this.editablePatient.screeningFailureReason ||
          this.editablePatient.screeningFailureReason.trim() === "") {

          this.screeningError = true;
          return;
        }
      }
      const selectedCohort = this.cohortList.find(
        c => c.id === this.editablePatient.cohortId
      );

      if (selectedCohort) {
        this.editablePatient.cohortName = selectedCohort.cohortName;
        this.editablePatient.cohortCode = selectedCohort.cohortCode;
      }



      axios.put(
        `${this.baseapi}/management/patient/updatepatient`,
        this.editablePatient,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          alert("Subject updated successfully");

          this.patient = { ...this.editablePatient };

          this.isEditMode = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getUsers() {
      const idtoken = store.getters.getIdToken;
      const studyId = store.getters.getStudyIs;

      const res = await axios.get(
        `${this.baseapi}/management/study/getusersinstudy?StudyId=${studyId}`,
        { headers: { Authorization: "Bearer " + idtoken } }
      );

      this.users = res.data;
    },

    async getCountries() {
      const idtoken = store.getters.getIdToken;

      const res = await axios.get(
        `${this.baseapi}/management/patient/getallcountry`,
        { headers: { Authorization: "Bearer " + idtoken } }
      );

      this.countries = res.data;
    },

    async getLanguages() {
      const idtoken = store.getters.getIdToken;

      const res = await axios.get(
        `${this.baseapi}/forms/template/languages`,
        { headers: { Authorization: "Bearer " + idtoken } }
      );

      this.languages = res.data;
    },
    handleScheduleRefresh() {
      this.$refs.SubjectSchedule.refreshVisits();
    },
    async getCohortList() {
      const idtoken = store.getters.getIdToken;
      const studyId = store.getters.getStudyIs;

      await axios
        .get(`${this.baseapi}/management/cohort/search?StudyId=${studyId}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.cohortList = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    refreshData() {
      this.getPatientById();
      this.handleScheduleRefresh();
    },
    updateInviteButtonState() {

      const hasSelectedTemplate =
        !!this.selectedTemplateId;

      const hasSelectedDocument =
        !!this.selectedDocumentId;

      // ReConsent -> no email required
      if (this.inviteConsentType === "ReConsent") {

        this.inviteButtonstats =
          !(hasSelectedTemplate && hasSelectedDocument);

        return;
      }

      const hasValidEmail =
        this.getInviteEmailPattern().test(
          (this.inviteEmail || "").trim()
        );

      this.inviteButtonstats =
        !(hasValidEmail &&
          hasSelectedTemplate &&
          hasSelectedDocument);
    },

    OnUserTypeOnEmailField() {
      this.err = "";
      this.validateInviteField("inviteEmail");
      this.updateInviteButtonState();
    },

    async saveInvitePopupForm() {
      if (!this.showInvitePopup || !this.selectedTemplateId) {
        return null;
      }

      await this.$nextTick();
      const dynamicFormRef = this.$refs.inviteDynamicForm;

      if (!dynamicFormRef) {
        throw new Error("Please select an eCRF form and wait for it to load.");
      }

      dynamicFormRef.subjectidforsend = this.subjectid;
      dynamicFormRef.sendData.subjectId = this.subjectid;
      dynamicFormRef.sendData.siteId = this.patient?.siteId || "";
      dynamicFormRef.visitname = this.selectedFormName || "e-Consent Form";
      dynamicFormRef.visitno = dynamicFormRef.visitno || "";

      const formId = await dynamicFormRef.saveFormAndReturnId();

      if (!formId) {
        throw new Error("Failed to save the eCRF form. Please review the form and try again.");
      }

      return formId;
    },
    async inviteSubject(consenttype = 'eConsent') {
      this.err = "";
      if (!this.validateInviteForm()) {
        this.updateInviteButtonState();
        return;
      }
      if (!this.uploadedConsentFile && this.consentType === "Wet Ink") {
        alert("Please select a file.");
      }
      else {

        if (this.consentType === "Wet Ink") {
          const confirmed = confirm(
            "Are you sure you want to upload the signed consent form and complete the consent process?"
          );
          if (!confirmed) {
            return;
          }
        }
        const idtoken = store.getters.getIdToken;
        this.isInviting = true;

        try {
          const formId = await this.saveInvitePopupForm();
          const invitePayload = {
            emailID:
              this.consentType !== "Wet Ink"
                ? (this.inviteEmail || "").trim()
                : (this.patientLogin?.emailID || null),
            studyID: this.name,
            subjectID: this.subjectid,
            templateID: this.selectedTemplateId,
            version: this.patient?.consentVersion,
            icfFormId: this.selectedDocumentId,
            formId: formId,
            siteId: this.patient?.siteId,
            consentType: this.consentType,
            isReConsent: consenttype === "ReConsent"
          };

          await axios.post(
            `${this.baseapi}/account-core/user/invitesubject`,
            invitePayload,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
            .then((res) => {
              this.consentRecordId = res.data;
              console.log("Invite response:", res.data);
            });

          await this.getDocuments();
          this.fetchConsentAuditData();
          this.getPatientById();

          if (this.consentType === "Wet Ink") {
            await this.uploadWetInkDocument();
            await this.updateConsent();
            await this.getDocuments();
          }
          
          if (this.consentType !== "Wet Ink") {
            alert(
              consenttype === "ReConsent"
                ? "Re-consent sent successfully"
                : this.$t("navigations.e-consent sent successfully")
            );
          }
          else {
            alert("Consent Form Uploaded and Consent Process Completed");
          }
          this.closeInvitePopup();
        } catch (err) {
          this.err = "";

          if (err.response?.data) {
            if (err.response.data.errors?.EmailID?.[0] === "The EmailID field is required.") {
              this.err = err.response.data.errors.EmailID[0];
            } else if (err.response.data.errors?.StudyName?.[0] === "The StudyName field is required.") {
              this.err = err.response.data.errors.StudyName[0];
            } else if (err.response.data.errors?.SubjectID?.[0] === "The SubjectID field is required.") {
              this.err = err.response.data.errors.SubjectID[0];
            } else if (err.response.data.message) {
              this.err = err.response.data.message;
            } else {
              this.err = "Failed to send e-consent invitation. Please try again.";
            }
          } else if (err.message) {
            this.err = err.message;
          } else {
            this.err = "Failed to send e-consent invitation. Please try again.";
          }

          console.error("Error in inviteSubject:", err);
        } finally {
          this.isInviting = false;
        }
      }
    },

    async updateConsent() {
      const idtoken = store.getters.getIdToken;
      const studyId = store.getters.getStudyIs;
      try {
        await axios.put(
          `${this.baseapi}/management/patientdocument/updateconsentbysubject`,
          {
            consentId: this.consentRecordId,
            studyID: studyId,
            subjectID: this.patient.patientId,
            status: "CONSENT_COMPLETED"
          },
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
      } catch (error) {
        console.error("Error updating consent status:", error);
      }
    },
    ClosePopUp() {
      this.closeInvitePopup();
    },
    CloseconsentPopUp() {
      this.closeInvitePopup();
    },
    async getAuditCompletionDetails(patientId) {
      try {
        const idtoken = store.getters.getIdToken;
        const response = await axios.get(
          `${this.baseapi}/management/patientschedule/getpatientshedule?patientID=${patientId}&ItemCount=500&sortprop=VisitNo`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        // Return the audit completion data (assuming it's the first or relevant entry)
        if (response.data && response.data.data && response.data.data.length > 0) {
          // Find the consent-related schedule item (you might need to filter by form type)
          const consentSchedule = response.data.data.find(
            item => item.templateName === "Informed Consent" ||
              item.activityName === "Informed Consent"
          );

          return consentSchedule || response.data.data[0];
        }
        return null;
      } catch (error) {
        console.error("Error fetching audit completion details:", error);
        return null;
      }
    },
    async getEConsentForms() {
      const idtoken = store.getters.getIdToken;
      const studyId = store.getters.getStudyIs;

      try {
        const response = await axios.get(
          `${this.baseapi}/forms/template/listtemplate?StudyID=${studyId}&Category=e-Consent`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        const templates = response.data.results || [];

        // Filter templates with category "e-Consent" and status "Approved"
        // Also include templates where category is exactly "e-Consent" (case-sensitive check)
        const eConsentTemplates = templates.filter(template => {
          return template.category === "e-Consent" && template.status === "Approved";
        });

        // Sort by templateName and then by version (newest first)
        eConsentTemplates.sort((a, b) => {
          if (a.templateName === b.templateName) {
            // Same template name, sort by version descending
            const versionA = parseFloat(a.version) || 0;
            const versionB = parseFloat(b.version) || 0;
            return versionB - versionA;
          }
          // Different template names, sort alphabetically
          return a.templateName.localeCompare(b.templateName);
        });

        this.eConsentTemplates = eConsentTemplates;

        console.log("e-Consent Templates (each version separately):", this.eConsentTemplates);


      } catch (error) {
        console.error("Error fetching e-Consent forms:", error);
        this.eConsentTemplates = [];
      }
    },
    async getSubjectDocuments() {
      const idtoken = store.getters.getIdToken;
      this.showDocumentLoading = true;

      try {
        const response = await axios.get(
          `${this.baseapi}/etmf/document/getdocumentsbysubject?subjectId=${this.subjectId}&studyId=${store.getters.getStudyIs}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.documentList = response.data || [];
      } catch (error) {
        console.error("Error fetching documents:", error);
        this.documentList = [];
      } finally {
        this.showDocumentLoading = false;
      }
    },


    async viewDocument(documentId, documentName, version) {
      this.$router.push({
        path: `/documentview/${documentId}/${version}`,
        query: { hideDocumentViewIcons: "true" },
      })
    },


    async loadDocumentPreview(documentId) {
      this.documentPreviewLoading = true;
      const idtoken = store.getters.getIdToken;

      try {
        const response = await axios.get(
          `${this.baseapi}/etmf/document/getdocument?documentId=${documentId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
            },
            responseType: 'blob'
          }
        );

        // Get file extension from content-type or filename
        const contentType = response.headers['content-type'];
        const blob = response.data;

        // Determine file type
        if (contentType.includes('pdf')) {
          this.documentFormat = 'pdf';
          this.documentSource = URL.createObjectURL(blob);
        } else if (contentType.includes('image')) {
          this.documentFormat = contentType.split('/')[1];
          this.documentSource = URL.createObjectURL(blob);
        } else if (contentType.includes('msword') || contentType.includes('officedocument')) {
          this.documentFormat = 'office';
          this.documentSource = URL.createObjectURL(blob);
          this.officePreviewUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${this.documentSource}`;
        } else {
          this.documentFormat = 'other';
          this.documentSource = URL.createObjectURL(blob);
        }
      } catch (error) {
        console.error("Error loading document preview:", error);
        this.documentFormat = 'error';
      } finally {
        this.documentPreviewLoading = false;
      }
    },

    closeDocumentViewModal() {
      this.showDocumentViewModal = false;
      this.currentDocument = {};
      this.documentSource = "";
      this.documentFormat = "";
      this.officePreviewUrl = "";
    },
    async getDocuments() {
      const idtoken = store.getters.getIdToken;
      this.showDocumentLoading = true;

      try {
        const response = await axios.get(
          `${this.baseapi}/management/patientdocument/listconsentformbystudy?StudyId=${store.getters.getStudyIs}&subjectId=${this.subjectId}&PageIndex=${this.pageindex}&PageSize=${this.pagesize}&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrder}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        // Store the results directly or map them preserving original fields
        //this.documentList = response.data.results || response.data || [];
        const results = response.data.results || response.data || [];
        this.subjectConsentForms = results.map(doc => ({
          ...doc,
          consentFormId: doc.consentFormId // Ensure this field is available
        }));
        this.consentFormsTotalPages = Math.ceil(
          (response.data.totalCount || results.length) / this.pagesize
        );
        console.log("Documents loaded:", this.documentList);
      } catch (error) {
        console.error("Error fetching documents:", error);
        this.subjectConsentForms = [];
      } finally {
        this.showDocumentLoading = false;
      }
    },
    async getConsentAuditByFormId(formId, selectedDocument = null) {
      const idtoken = store.getters.getIdToken;

      try {
        const response = await axios.get(
          `${this.baseapi}/management/patientdocument/listconsentformbystudy?StudyId=${store.getters.getStudyIs}&subjectId=${this.subjectId}&PageIndex=${this.pageindex}&PageSize=${this.pagesize}&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrder}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        const documents = response.data.results || response.data.data || response.data || [];
        const consentDocument =
          documents.find((item) => item.formId === formId) ||
          selectedDocument ||
          {};

        this.consentList = [
          this.mapConsentAuditDocument(consentDocument)
        ];
      } catch (error) {
        console.error("Error fetching consent audit details:", error);
        this.consentList = selectedDocument
          ? [this.mapConsentAuditDocument(selectedDocument)]
          : [];
      }
    },
    mapConsentAuditDocument(document = {}) {
      return {
        id: document.formId || document.id || this.patient?.patientId || "",
        sentBy:
          document.sentBy ||
          document.createdUserName ||
          document.createdBy ||
          document.uploadedBy ||
          this.patient?.createdUserName ||
          "System Admin",
        createdDate:
          document.createdDate ||
          document.createdAt ||
          document.uploadedAt ||
          this.patient?.createdAt,
        consentStatus:
          document.consentStatus ||
          document.status ||
          this.patient?.consentStatus ||
          "",
        signedDate:
          document.signedDate ||
          document.consentSignedDate ||
          document.signedAt ||
          this.patient?.consentSignedDate,
        consnetFormViewedBy:
          document.consnetFormViewedBy ||
          document.consentFormViewedBy ||
          document.formViewedBy ||
          this.patient?.consnetFormViewedBy,
        consnetFormViewedAt:
          document.consnetFormViewedAt ||
          document.consentFormViewedDate ||
          document.consentFormViewedAt ||
          document.formViewedAt ||
          this.patient?.consnetFormViewedAt,
        formVerifiedBy:
          document.formVerifiedBy ||
          document.verifiedBy ||
          this.patient?.formVerifiedBy,
        formVerifiedAt:
          document.formVerifiedAt ||
          document.verifiedAt ||
          this.patient?.formVerifiedAt,
        markedCompleteBy:
          document.markedCompleteBy ||
          document.auditCompletionBy ||
          document.completedBy ||
          null,
        completionDate:
          document.completionDate ||
          document.auditCompletionDate ||
          document.completedAt ||
          null
      };
    },
    async getConsentDocuments() {
      const idtoken = store.getters.getIdToken;
      this.showDocumentLoading = true;

      try {
        const response = await axios.get(
          `${this.baseapi}/management/patientdocument/listicfformsbystudy?studyId=${store.getters.getStudyIs}`,

          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );


        let documents = [];
        if (response.data?.entities) {
          documents = response.data.entities;
        } else if (response.data?.data) {
          documents = response.data.data;
        } else if (Array.isArray(response.data)) {
          documents = response.data;
        } else if (response.data?.results) {
          documents = response.data.results;
        } else {
          documents = [];
        }

        this.availableICFForms = documents;

        console.log("Consent Documents loaded for dropdown:", this.documentList);

      } catch (error) {
        console.error("Error fetching consent documents:", error);
        this.documentList = [];
      } finally {
        this.showDocumentLoading = false;
      }
    },
    fetchConsentDocuments() {
      return this.getConsentDocuments();
    },
    async deleteDocument(consentFormId) {
      console.log("Deleting document with ID:", consentFormId);

      if (!confirm(this.$t('navigations.are you sure you want to delete this document?'))) {
        return;
      }

      const idtoken = store.getters.getIdToken;

      try {
        const response = await axios.delete(
          `${this.baseapi}/management/patientdocument/deleteconsentform?id=${consentFormId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data && (response.data.message || response.data.success)) {
          alert(response.data.message || this.$t('navigations.document deleted successfully'));
        } else {
          alert(this.$t('navigations.document deleted successfully'));
        }

        await this.getDocuments();

      } catch (error) {
        console.error("Error deleting document:", error);

        if (error.response?.data?.message) {
          alert(error.response.data.message);
        } else if (error.response?.data?.errors) {
          const errorMessages = Object.values(error.response.data.errors).flat();
          alert(errorMessages.join('\n'));
        } else {
          alert(this.$t('navigations.error deleting document'));
        }
      }
    },
    viewICFForm(formData) {
      const formId = formData?.eCRFFormId;

      if (formId) {
        const subjectId =
          formData?.subjectId ||
          formData?.subjectID ||
          this.patient?.patientId ||
          this.subjectId ||
          "";
        const studyId = formData?.studyId || formData?.studyID || store.getters.getStudyIs || "";
        let consentRecordId = formData?.consentRecordId || "";
        localStorage.setItem("patientId", subjectId);
        localStorage.setItem("consentSubjectId", subjectId);
        localStorage.setItem("consentStudyId", studyId);
        localStorage.setItem("consentRecordId", consentRecordId);
        // Navigate to form view
        const archive = false; // Set to true if you want to view archived forms
        this.$router.push(`/editForm/subjectprofile/${formId}/${archive}`);
      } else {
        console.error("Cannot view form: No form ID found", formData);
        alert("Unable to view this form. Form ID is missing.");
      }
    },
    getICFDocumentId(icf) {
      return (
        icf?.signedICF?.signedicfDocumentId ||
        icf?.signedICF?.signedICFDocumentId ||
        icf?.signedICF?.signedIcfDocumentId ||
        icf?.signedICF?.documentId ||
        icf?.signedICF?.documentID ||
        icf?.signedICF?.storagePath ||
        icf?.icf?.icfDocumentId ||
        icf?.documentId ||
        icf?.documentReferenceId ||
        icf?.documentID ||
        ""
      );
    },

    getICFDocumentVersion(icf) {
      return (
        icf?.icf?.version ||
        icf?.versionNumber ||
        icf?.latestVersion ||
        icf?.version ||
        icf?.versionId ||
        0
      );
    },

    async viewConsentdocument(icf) {
      const documentId = this.getICFDocumentId(icf);
      const version = this.getICFDocumentVersion(icf);
      const consentRecordId = icf?.consentRecordId || "";
      const subjectId =
        icf?.subjectId ||
        icf?.subjectID ||
        this.patient?.patientId ||
        this.subjectId ||
        "";
      const studyId = icf?.studyId || icf?.studyID || store.getters.getStudyIs || "";

      if (!documentId) {
        alert("Document id is missing.");
        return;
      }

      if (consentRecordId) {
        localStorage.setItem("consentRecordId", consentRecordId);
        localStorage.setItem("consentSubjectId", subjectId);
        localStorage.setItem("consentStudyId", studyId);
        localStorage.setItem("documentViewSource", "subjectprofile-consent-record-icf");
      } else {
        localStorage.removeItem("consentRecordId");
        localStorage.removeItem("consentSubjectId");
        localStorage.removeItem("consentStudyId");
        localStorage.removeItem("documentViewSource");
      }

      const route = {
        path: `/documentview/${documentId}/${version}`,
        query: { hideDocumentViewIcons: "true" },
      };
      if (consentRecordId) {
        route.query = {
          ...route.query,
          source: "subjectprofile-consent-record-icf",
          consentRecordId,
          subjectId,
          studyId,
        };
      }

      this.$router.push(route);
    },
    async fetchConsentAuditData(consentRecordId) {

      const idtoken = store.getters.getIdToken;

      this.auditEvents = [];
      this.isLoadingAudit = true;
      this.expandedMetadataIndex = null;

      try {

        const response = await axios.get(
          `${this.baseapi}/management/patientdocument/listconsentformbystudy`,
          {
            params: {
              StudyId: store.getters.getStudyIs,
              subjectId: this.subjectId,
              PageIndex: 1,
              PageSize: 100,
            },
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        const results = response.data?.results || [];

        // FIND ONLY CLICKED RECORD
        const selectedRecord = results.find(
          item => item.consentRecordId === consentRecordId
        );

        // SAVE LATEST DATA
        this.selectedConsentRecord = selectedRecord || this.selectedConsentRecord;

        // ONLY SELECTED EVENTS
        this.auditEvents = (selectedRecord?.events || []).map((event) => ({
          eventType: event.eventType,
          eventAt: event.eventAt,
          status: event.status,
          message: event.message,
          userName: event.userName,
          userType: event.userType,
          metadata: event.metadata || [],
        }));

        console.log("SELECTED AUDIT EVENTS", this.auditEvents);

      } catch (error) {

        console.error("Error fetching consent audit data:", error);

        this.auditEvents = [];

      } finally {

        this.isLoadingAudit = false;
      }
    },
    getViewedBy(record) {
      const viewEvent = record.events?.find(e => e.eventType === 'Viewed');
      if (viewEvent) {
        return viewEvent.userName || viewEvent.userId || '—';
      }
      return '—';
    },


    getViewedAt(record) {
      const viewEvent = record.events?.find(e => e.eventType === 'Viewed');
      return viewEvent?.eventAt || null;
    },
    getConsentStatus(record) {
      if (record.outcome) return record.outcome;
      if (record.status) return record.status;
      const lastEvent = record.events?.slice(-1)[0];
      return lastEvent?.message || '—';
    },
    loadConsentFormsPage(page) {
      if (page < 1 || page > this.consentFormsTotalPages) return;
      this.consentFormsPageIndex = page;
      this.getDocuments();
    },
    getInitials(name) {
      if (!name) return "--";
      return name.substring(0, 2).toUpperCase();
    },

    getEventIcon(type) {
      const icons = {
        CONSENT_INVITED: "fa fa-envelope",
        "SUBJECT_VIEWED": "fa fa-eye",
        ICF_SIGNED: "fa fa-pencil",
        ECRF_VIEWED_BY_INVESTIGATOR: "fa fa-eye",
        INVESTIGATOR_SIGNED: "fa fa-pencil",
        CONSENT_COMPLETED: "fa fa-check"
      };

      return icons[type] || "fa fa-info-circle";
    },

    getEventColor(type) {
      const colors = {
        CONSENT_INVITED: "#185FA5",
        "SUBJECT_VIEWED": "#0F6E56",
        ICF_SIGNED: "#0F6E56",
        ECRF_VIEWED_BY_INVESTIGATOR: "#854F0B",
        INVESTIGATOR_SIGNED: "#185FA5",
        CONSENT_COMPLETED: "#1D9E75"
      };

      return colors[type] || "#185FA5";
    },

    getEventBg(type) {
      const bg = {
        CONSENT_INVITED: "#E6F1FB",
        "SUBJECT_VIEWED": "#E1F5EE",
        ICF_SIGNED: "#E1F5EE",
        ECRF_VIEWED_BY_INVESTIGATOR: "#FAEEDA",
        INVESTIGATOR_SIGNED: "#E6F1FB",
        CONSENT_COMPLETED: "#E1F5EE"
      };

      return bg[type] || "#E6F1FB";
    },
    toggleMetadataExpand(index) {
      this.expandedMetadataIndex = this.expandedMetadataIndex === index ? null : index;
    },
    formatDate(iso) {
      if (!iso) return "-";
      const d = new Date(iso);
      return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    },
    toTime(iso) {
      if (!iso) return "-";

      const d = new Date(iso);

      return d.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
      });
    },
    closePage() {
        this.$router.back();
    },


  }
};
